module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-box"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.product.ProductName)), _c('br'), _vm._v(" 物料编码：" + _vm._s(_vm.product.ProductCode))]), _vm._v(" "), _c('td', [_c('el-tag', {
    attrs: {
      "type": _vm._f("ConditionColor")(_vm.product.ConditionName)
    }
  }, [_vm._v(_vm._s(_vm.product.ConditionName))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.ProductBrandName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.ProductModelName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.ProductModuleName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("amount")(_vm.product.RentalUnitPrice)))]), _vm._v(" "), _c('td', [_c('el-input-number', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "数量",
      "min": 1,
      "max": _vm.deliveryType === 'immediateDelivery' ? _vm.product.Quantity : Infinity
    },
    model: {
      value: (_vm.product.RentalQuantity),
      callback: function($$v) {
        _vm.product.RentalQuantity = $$v
      },
      expression: "product.RentalQuantity"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-select', {
    attrs: {
      "placeholder": "租赁周期"
    },
    on: {
      "change": _vm.handleRentalPeriodChange
    },
    model: {
      value: (_vm.product.RentalPeriod),
      callback: function($$v) {
        _vm.product.RentalPeriod = $$v
      },
      expression: "product.RentalPeriod"
    }
  }, _vm._l((_vm.rentalPeriods), function(item) {
    return _c('el-option', {
      key: item.PeriodInMonths,
      attrs: {
        "label": item.PeriodInMonths + '个月',
        "value": item.PeriodInMonths,
        "disabled": _vm.orderType === 'flexibleTerm' ? item.PeriodInMonths !== 3 : false
      }
    })
  }))], 1), _vm._v(" "), _c('td', [_c('el-select', {
    attrs: {
      "placeholder": "保修周期"
    },
    model: {
      value: (_vm.product.WarrantyMonths),
      callback: function($$v) {
        _vm.product.WarrantyMonths = $$v
      },
      expression: "product.WarrantyMonths"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无保修",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3个月",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "6个月",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "9个月",
      "value": 9
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "12个月",
      "value": 12
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("amount")(_vm.product.SubTotalRentalAmount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("amount")(_vm.product.Deposit)))])])])]), _vm._v(" "), _c('el-button', {
    staticClass: "delete-btn",
    on: {
      "click": function () { return this$1.$emit('delete', _vm.index); }
    }
  }, [_vm._v("X")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    attrs: {
      "width": "180"
    }
  }, [_vm._v("物料名称")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("品项")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("品牌")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("机型")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("模块")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("租赁单价")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "140"
    }
  }, [_vm._v("租赁周期")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "120"
    }
  }, [_vm._v("保修")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("租金费用")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("押金额度")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b2e457e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Inventory/LeaseApplyForm.vue
// module id = 714
// module chunks = 0